// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1ygQg","vLegacy":"SelectSecondary_vLegacy__2lcYb","error":"SelectSecondary_error__30ond","disabled":"SelectSecondary_disabled__8ytc-"};